export const slugify = (text) => {
    if (!text) return "";
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')     // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-')   // Replace multiple - with single -
        .replace(/^-+/, '')       // Trim - from start of text
        .replace(/-+$/, '');      // Trim - from end of text
};

// precio_eur holds one price per size; the first one above zero is the bike's price.
export const bikePrice = (bike) => {
    const prices = Array.isArray(bike?.precio_eur) ? bike.precio_eur : [bike?.precio_eur];
    return prices.map(Number).find((p) => p > 0) || null;
};

// Cheapest first (or most expensive with descending); bikes without a price always go last.
export const sortByPrice = (bikes, descending = false) => [...bikes].sort((a, b) => {
    const pa = bikePrice(a);
    const pb = bikePrice(b);
    if (pa === null || pb === null) return (pa === null) - (pb === null);
    return (descending ? pb - pa : pa - pb) || String(a.modelo).localeCompare(String(b.modelo));
});

export const formatPrice = (price, type = 'bikes', serieId = null) => {
    // Normalize price: handle arrays (common in DB samples) or strings
    const val = Array.isArray(price) ? price[0] : price;
    const num = parseFloat(val);

    if (isNaN(num)) return type === 'bikes' ? 'USD $0.00' : 'RD$ 0.00';

    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    if (type === 'bikes') {
        return `USD $${formatter.format(num)}`;
    } else {
        return `RD$ ${formatter.format(num)}`;
    }
};
